import { ReferralDashboard } from '../../components/Billing/ReferralDashboard';
import { PageHeader } from '../../components/Common/PageHeader';

export function AccountReferralsPage() {
  return (
    <>
      <PageHeader
        title="Referrals"
        subtitle="Share your link to earn 10% on every paid signup — they get 10% too."
      />
      <ReferralDashboard />
    </>
  );
}
